var _defs, _polyline, _polyline2, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _circle, _path7, _circle2, _path8, _path9, _path10, _g, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse8, _ellipse9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiitverseLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1236.38 197.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-width:3px;}.cls-1,.cls-2,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-5,.cls-6,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-1{stroke:url(#D\xE9grad\xE9_sans_nom_103);}.cls-2{stroke:url(#D\xE9grad\xE9_sans_nom_103-2);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_4);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_4-2);}.cls-5,.cls-6,.cls-7,.cls-8{fill:#ff00e1;stroke-width:5px;}.cls-5{stroke:url(#D\xE9grad\xE9_sans_nom_12);}.cls-6{stroke:url(#D\xE9grad\xE9_sans_nom_12-2);}.cls-7{stroke:url(#D\xE9grad\xE9_sans_nom_12-3);}.cls-8{stroke:url(#D\xE9grad\xE9_sans_nom_12-4);}.cls-9{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2);}.cls-10{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-2);}.cls-11{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-3);}.cls-12{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-4);}.cls-13{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-5);}.cls-14{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-6);}.cls-15{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-7);}.cls-16{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-8);}.cls-17{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_2-9);}.cls-18{opacity:0.65;}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_144);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_144-2);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_144-3);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_144-4);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_144-5);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_144-6);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_144-7);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_144-8);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_144-9);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_4-3);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_4-4);}.cls-30,.cls-31,.cls-48,.cls-49{opacity:0.63;}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_4-5);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_4-6);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_4-7);}.cls-33,.cls-34,.cls-35,.cls-36,.cls-37{fill:#29235c;stroke-width:11px;}.cls-33{stroke:url(#D\xE9grad\xE9_sans_nom_108);}.cls-34{stroke:url(#D\xE9grad\xE9_sans_nom_108-2);}.cls-35{stroke:url(#D\xE9grad\xE9_sans_nom_108-3);}.cls-36{stroke:url(#D\xE9grad\xE9_sans_nom_108-4);}.cls-37{stroke:url(#D\xE9grad\xE9_sans_nom_108-5);}.cls-38{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_1);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_107);}.cls-40{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_1-2);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_107-2);}.cls-42{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_1-3);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_107-3);}.cls-44{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_1-4);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_107-4);}.cls-46{fill:url(#Nouvelle_nuance_de_d\xE9grad\xE9_1-5);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_107-5);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_4-8);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_4-9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_103",
    x1: 750.54,
    y1: -92.47,
    x2: 1113.04,
    y2: 270.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27348b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00fff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#29235c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e50681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ea9b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_103-2",
    x1: 725.73,
    y1: -108.4,
    x2: 1097.67,
    y2: 263.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_103"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4",
    cx: 818.78,
    cy: 31.54,
    r: 25.71,
    gradientTransform: "translate(0 27.71) scale(1 0.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-2",
    cx: 1062.61,
    cy: 177.62,
    r: 25.71,
    gradientTransform: "translate(0 156.06) scale(1 0.12)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_12",
    x1: 187.97,
    y1: 51.12,
    x2: 187.97,
    y2: 197.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff00e1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff8",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_12-2",
    x1: 558.4,
    y1: 21.59,
    x2: 558.4,
    y2: 197.13,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_12-3",
    x1: 464.9,
    y1: 0,
    x2: 464.9,
    y2: 197.13,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_12-4",
    x1: 402.72,
    y1: 0,
    x2: 402.72,
    y2: 197.13,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2",
    x1: 77.93,
    y1: 183.47,
    x2: 77.93,
    y2: 17.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#27348b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#36a9e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#073de3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#29235c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e50681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ea9b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-2",
    x1: 256.22,
    y1: 183.47,
    x2: 256.22,
    y2: 17.9,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-3",
    x1: 558.4,
    y1: 183.47,
    x2: 558.4,
    y2: 17.9,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-4",
    x1: 476.95,
    y1: 183.47,
    x2: 476.95,
    y2: 17.9,
    gradientTransform: "translate(11.3 -75.98) rotate(9.22)",
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-5",
    x1: 464.82,
    y1: 183.47,
    x2: 464.82,
    y2: 17.9,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-6",
    x1: 414.45,
    y1: 183.47,
    x2: 414.45,
    y2: 17.9,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-7",
    x1: 402.31,
    y1: 183.47,
    x2: 402.31,
    y2: 17.9,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-8",
    x1: 460.18,
    y1: 183.47,
    x2: 460.18,
    y2: 17.9,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_2-9",
    x1: 398.34,
    y1: 183.47,
    x2: 398.34,
    y2: 17.9,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144",
    x1: 24.69,
    y1: 72.02,
    x2: 127.48,
    y2: 174.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-2",
    x1: 178.34,
    y1: 21.87,
    x2: 328.11,
    y2: 171.64,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-3",
    x1: 502.41,
    y1: 46.14,
    x2: 625.49,
    y2: 169.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-4",
    x1: 457.28,
    y1: 12.42,
    x2: 490.63,
    y2: 45.76,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-5",
    x1: 443.95,
    y1: 58.96,
    x2: 484.53,
    y2: 99.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-6",
    x1: 394.77,
    y1: 12.42,
    x2: 428.12,
    y2: 45.76,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-7",
    x1: 381.44,
    y1: 58.96,
    x2: 422.02,
    y2: 99.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-8",
    x1: 430.33,
    y1: 133.9,
    x2: 469.06,
    y2: 172.63,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144-9",
    x1: 368.49,
    y1: 133.9,
    x2: 407.22,
    y2: 172.63,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_144"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-3",
    cx: 162.85,
    cy: 60.14,
    r: 24.8,
    gradientTransform: "translate(0 52.84) scale(1 0.12)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-4",
    cx: 77.93,
    cy: 57.68,
    r: 24.8,
    gradientTransform: "translate(0 50.68) scale(1 0.12)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-5",
    cx: 412.09,
    cy: 45.82,
    r: 24.8,
    gradientTransform: "translate(-1816.74 29.05) scale(5.42 0.12)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-6",
    cx: 404.08,
    cy: 40.52,
    r: 24.8,
    gradientTransform: "translate(-1250.12 23.63) scale(4.15 0.27)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-7",
    cx: 344.96,
    cy: 60.14,
    r: 24.8,
    gradientTransform: "translate(0 52.84) scale(1 0.12)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_108",
    x1: 704.25,
    y1: 61.73,
    x2: 704.25,
    y2: 157.88,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_108-2",
    x1: 809.8,
    y1: 59.96,
    x2: 809.8,
    y2: 159.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_108-3",
    x1: 913.98,
    y1: 61.25,
    x2: 913.98,
    y2: 157.88,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_108-4",
    x1: 1005.24,
    y1: 59.96,
    x2: 1005.24,
    y2: 159.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_108-5",
    x1: 1118.6,
    y1: 59.96,
    x2: 1118.6,
    y2: 159.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_1",
    x1: 702,
    y1: 151.51,
    x2: 702,
    y2: 67.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#1d71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00fff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e50681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ea9b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e8777c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e6474f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e4232e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#e30e1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e30613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107",
    x1: 702.67,
    y1: 153.3,
    x2: 702.67,
    y2: 62.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00fff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#29235c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e50681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ea9b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_1-2",
    x1: 808.76,
    y1: 151.51,
    x2: 808.76,
    y2: 67.21,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107-2",
    x1: 808.76,
    y1: 155.08,
    x2: 808.76,
    y2: 60.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_1-3",
    x1: 913.02,
    y1: 151.51,
    x2: 913.02,
    y2: 67.21,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107-3",
    x1: 912.97,
    y1: 153.3,
    x2: 912.97,
    y2: 61.68,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_1-4",
    x1: 1004.1,
    y1: 151.51,
    x2: 1004.1,
    y2: 67.21,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107-4",
    x1: 1004.16,
    y1: 155.08,
    x2: 1004.16,
    y2: 60.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nouvelle_nuance_de_d\\xE9grad\\xE9_1-5",
    x1: 1117.56,
    y1: 151.51,
    x2: 1117.56,
    y2: 67.21,
    xlinkHref: "#Nouvelle_nuance_de_d\\xE9grad\\xE9_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107-5",
    x1: 1117.56,
    y1: 155.08,
    x2: 1117.56,
    y2: 60.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_107"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-8",
    cx: 440.13,
    cy: 139.83,
    r: 25.17,
    gradientTransform: "translate(-1822.93 110.79) scale(5.69 0.12)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-9",
    cx: 440.74,
    cy: 82.41,
    r: 25.17,
    gradientTransform: "translate(-1227.72 105.37) scale(4.36 0.27)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "616.89 42.68 1234.38 42.68 1191.81 188.63 680.96 188.63"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "652.34 177.62 1180.96 177.62 1223.09 31.54 587.3 31.54"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 818.78,
    cy: 31.54,
    rx: 26.67,
    ry: 3.63
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1062.61,
    cy: 177.62,
    rx: 26.67,
    ry: 3.63
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372.06,59.65a8,8,0,0,0-6.62-3.51H327.67a8,8,0,0,0-7.53,5.29l-20,55.43L281,61.53a8,8,0,0,0-7.56-5.39H240.88a8,8,0,0,0-7.56,5.39l-19.19,55.41L193.91,61.41a8,8,0,0,0-7.52-5.27H147a8,8,0,0,0-7.44,11l1.68,4.23C125.89,60.13,103.31,53.62,79,53.62c-20.23,0-37.43,4.39-49.73,12.71-13,8.75-20.09,21.72-20.09,36.51,0,13.09,5.17,23.26,15.38,30.3a7.91,7.91,0,0,0-3.15,2.62L4,160.25a8,8,0,0,0,.82,10.24c15.06,15.32,43.56,24.83,74.38,24.83,20.79,0,38.53-4,51.32-11.49,14.95-8.8,22.86-22.08,22.86-38.41,0-15.65-7.35-27.2-21.85-34.31q-1.24-.61-2.55-1.17l.24-.26,18.69-21.62,39.53,99.69a8,8,0,0,0,7.44,5.06h33.66a8,8,0,0,0,7.52-5.28l20.18-55.71,20.19,55.71a8,8,0,0,0,7.52,5.28h33.66a8,8,0,0,0,7.44-5.06L372.87,67.09A8,8,0,0,0,372.06,59.65ZM123.14,104.44c-11-10.07-27.23-15.8-46-15.8-15.56,0-23.81,3.89-23.81,10.07,0,6.65,8,7.33,34.12,10.31,30.91,3.66,57.93,8.93,57.93,36.4,0,28.16-28.4,41.9-66.18,41.9-27.93,0-54.72-8.24-68.68-22.44l17.39-24.49c14.43,13.28,33.44,19.68,54,19.68,16.49,0,26.56-3.2,26.56-10.75,0-8-11.45-8-38.46-11.23-28.85-3.66-52.89-9.38-52.89-35.25,0-24.73,23.58-41.22,61.82-41.22,28.39,0,51.05,9.16,63.19,20.84Zm-14.06-.29c-6.92-1.36-14-2.28-20.71-3.07l-2.62-.3c-8.28-1-16.23-1.85-21.11-2.81a46.6,46.6,0,0,1,12.48-1.33C89.28,96.64,100.28,99.26,109.08,104.15ZM41.36,140.78C50,143.34,59.6,144.83,69,146h.07c3.73.44,7.22.83,10.29,1.17,7.57.84,15.33,1.71,19.42,2.75-2.27.93-7.09,2.11-16.87,2.11C66.5,152.07,52.67,148.2,41.36,140.78Zm276.23,44H283.93l-27.71-76.48-27.7,76.48H194.86L147,64.14h39.38l27.93,76.7,26.56-76.7h32.51L300,140.84l27.72-76.7h37.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625.61,177.53,619,148.45a8,8,0,0,0-10.39-5.79c-6.25,2.15-14.56,4.6-23.51,4.6-14.67,0-14.67-4.56-14.67-9.85v-35h42.15a8,8,0,0,0,8-8V64.14a8,8,0,0,0-8-8H570.4v-24a8,8,0,0,0-8-8H526.46a8,8,0,0,0-8,8v24h-9.94a8,8,0,0,0-7.63,5.6L491.35,92A8,8,0,0,0,499,102.37h19.48v43.28c0,16.37,6.06,29.5,17.52,38,9.83,7.3,23.12,11,39.47,11,15.54,0,32-2.86,45.19-7.84A8,8,0,0,0,625.61,177.53Zm-50.16,9.1c-27.24,0-49-11.44-49-41V94.37H499l9.54-30.23h17.94v-32H562.4V64.14h50.15V94.37H562.4v43c0,13.05,7.33,17.85,22.67,17.85,9.39,0,18.09-2.28,26.11-5l6.63,29.08A123.69,123.69,0,0,1,575.45,186.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M476.82,120.19a5.86,5.86,0,0,0,.26-.57L496.94,67a8,8,0,0,0-4-10,29.59,29.59,0,1,0-33.2-.82H448.2a8,8,0,0,0-7.57,5.43l-7,20.67A24.36,24.36,0,0,0,435,101.68c3,5.75,8,10.31,13.22,13.8a8,8,0,0,0-1.45,2.51l-23.05,66a8,8,0,0,0,7.56,10.63h.48a98.45,98.45,0,0,0,25.15-5.6c18.18-6.63,31.26-17.86,37.83-32.46,3.16-7,3.12-14.14-.13-20.54C491,129,484,123.83,476.82,120.19Zm-21.46-88.1A21.59,21.59,0,1,1,477,53.68,21.59,21.59,0,0,1,455.36,32.09ZM441.17,84.82l7-20.68h41.25L469.6,116.8S433.89,106.21,441.17,84.82Zm46.24,68.46c-13.84,30.78-56.16,33.35-56.16,33.35l23-66S498,129.85,487.41,153.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M432.74,136c-3.67-7.21-11-12.45-18.3-16.1,0-.1.1-.19.14-.3L434.43,67a8,8,0,0,0-.9-7.38A8.2,8.2,0,0,0,430.45,57a29.6,29.6,0,1,0-33.21-.82H385.69a8,8,0,0,0-7.57,5.43l-7,20.67a24.32,24.32,0,0,0,1.38,19.44c3,5.91,8.27,10.55,13.64,14.08A8,8,0,0,0,384.9,118l-23,66a8,8,0,0,0,7.56,10.63h.48A98.45,98.45,0,0,0,395,189c18.18-6.63,31.26-17.86,37.83-32.46C436,149.52,436,142.42,432.74,136ZM392.85,32.09a21.6,21.6,0,1,1,21.6,21.59A21.6,21.6,0,0,1,392.85,32.09ZM378.66,84.82l7-20.68H427l-19.83,52.58c-2-.75-3.82-1.38-5.49-1.91C391.93,110.83,373.2,100.86,378.66,84.82Zm46.91,68.46c-13.84,30.78-56.16,33.35-56.16,33.35l23-66s2.66.56,6.5,1.76c3,1.2,5.18,1.88,5.87,2.08a2,2,0,0,0,.24,0C417,129.21,432.28,138.37,425.57,153.28Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.43,109c-26.1-3-34.12-3.66-34.12-10.31,0-6.18,8.25-10.07,23.81-10.07,18.79,0,35,5.73,46,15.8l19-22C130,70.78,107.35,61.62,79,61.62c-38.24,0-61.82,16.49-61.82,41.22,0,25.87,24,31.59,52.89,35.25,27,3.21,38.46,3.21,38.46,11.23,0,7.55-10.07,10.75-26.56,10.75-20.6,0-39.61-6.4-54-19.68L10.5,164.88c14,14.2,40.75,22.44,68.68,22.44,37.78,0,66.18-13.74,66.18-41.9C145.36,118,118.34,112.68,87.43,109Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "299.95 140.84 273.39 64.14 240.88 64.14 214.32 140.84 186.39 64.14 147.01 64.14 194.86 184.81 228.52 184.81 256.22 108.33 283.93 184.81 317.59 184.81 365.44 64.14 327.67 64.14 299.95 140.84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M611.18,150.23c-8,2.75-16.72,5-26.11,5-15.34,0-22.67-4.8-22.67-17.85v-43h50.15V64.14H562.4v-32H526.46V64.14H508.52L499,94.37h27.48v51.28c0,29.54,21.75,41,49,41a123.69,123.69,0,0,0,42.36-7.32Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 476.95,
    cy: 32.09,
    r: 21.59,
    transform: "translate(1.02 76.81) rotate(-9.22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M441.17,84.82c-7.28,21.39,28.43,32,28.43,32l19.85-52.66H448.2Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 414.45,
    cy: 32.09,
    r: 21.59
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M407.09,116.8,427,64.14H385.69l-7,20.68C371.38,106.21,407.09,116.8,407.09,116.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M456.29,117.63l-25,69s42.32-2.57,56.16-33.35C498,129.85,456.29,117.63,456.29,117.63Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M394.45,117.63l-25,69s42.32-2.57,56.16-33.35C436.1,129.85,394.45,117.63,394.45,117.63Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M76,58.62c28.39,0,51.05,9.16,63.19,20.84l-19,22c-11-10.07-27.23-15.8-46-15.8-15.56,0-23.81,3.89-23.81,10.07,0,6.65,8,7.33,34.12,10.31,30.91,3.66,57.93,8.93,57.93,36.4,0,28.16-28.4,41.9-66.18,41.9-27.93,0-54.72-8.24-68.68-22.44l17.39-24.49c14.43,13.28,33.44,19.68,54,19.68,16.49,0,26.56-3.2,26.56-10.75,0-8-11.45-8-38.46-11.23-28.85-3.66-52.89-9.38-52.89-35.25,0-24.73,23.58-41.22,61.82-41.22m0-2c-38.77,0-63.82,17-63.82,43.22,0,12.67,5.46,21.74,16.68,27.72,10.19,5.42,24.26,7.78,38,9.52,3.72.44,7.2.83,10.27,1.17,19.65,2.18,26.44,3.19,26.44,8.07,0,4-4.26,8.75-24.56,8.75-20.85,0-39.07-6.62-52.68-19.15l-1.67-1.54-1.32,1.85L5.87,160.73l-1,1.36,1.17,1.2c14,14.21,40.84,23,70.11,23,19.72,0,36.41-3.69,48.27-10.66,13-7.67,19.91-19.16,19.91-33.24,0-13.36-6.05-22.82-18.49-28.92-11.36-5.58-27.23-7.81-41.2-9.47l-2.6-.29c-11.89-1.36-19.75-2.25-24.47-3.57-4.89-1.36-5.29-2.83-5.29-4.46,0-5,8.36-8.07,21.81-8.07,18.07,0,33.94,5.43,44.67,15.28l1.52,1.39,1.35-1.56,19-22,1.24-1.43L140.54,78c-13.93-13.4-38.07-21.4-64.58-21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M362.44,61.14,314.59,181.81H280.93l-27.71-76.48-27.7,76.48H191.86L144,61.14h39.38l27.93,76.7,26.56-76.7h32.51L297,137.84l27.72-76.7h37.77m2.94-2H323.26l-.48,1.32L297,131.85,272.28,60.49l-.46-1.35H236.46L236,60.49l-24.72,71.38-26-71.41-.48-1.32H141.06l1.09,2.74L190,182.54l.5,1.27h36.42l.48-1.32,25.82-71.29,25.83,71.29.48,1.32H316l.5-1.27L364.3,61.88l1.08-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M559.4,29.09V61.14h50.15V91.37H559.4v43c0,13.05,7.33,17.85,22.67,17.85,9.39,0,18.09-2.28,26.11-5l6.63,29.08a123.69,123.69,0,0,1-42.36,7.32c-27.24,0-49-11.44-49-41V91.37H496l9.54-30.23h17.94v-32H559.4m2-2H521.46V59.14H504.05l-.44,1.4-9.54,30.22-.82,2.61h28.21v49.28c0,14.59,5.08,25.75,15.09,33.17,8.66,6.42,21.07,9.81,35.9,9.81s30.54-2.72,43.07-7.45l1.63-.62-.39-1.7-6.63-29.07-.5-2.17-2.1.72c-6.69,2.29-15.62,4.92-25.46,4.92-14.87,0-20.67-4.44-20.67-15.85v-41h50.15V59.14H561.4v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M474,7.5a21.59,21.59,0,1,1-21.59,21.59A21.59,21.59,0,0,1,474,7.5m0-2a23.59,23.59,0,1,0,23.59,23.59A23.61,23.61,0,0,0,474,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M486.45,61.14,466.6,113.8s-35.71-10.59-28.43-32l7-20.68h41.25m2.9-2H443.77l-.46,1.36-7,20.67a18.26,18.26,0,0,0,1,14.75c2.89,5.59,8.63,10.62,17.06,15A74.59,74.59,0,0,0,466,115.72l1.78.53.66-1.74,19.86-52.66,1-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M411.45,7.5a21.59,21.59,0,1,1-21.6,21.59A21.59,21.59,0,0,1,411.45,7.5m0-2A23.59,23.59,0,1,0,435,29.09,23.62,23.62,0,0,0,411.45,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M424,61.14,404.09,113.8s-35.71-10.59-28.43-32l7-20.68H424m2.89-2H381.26l-.46,1.36-7,20.67a18.22,18.22,0,0,0,1,14.75c2.88,5.59,8.62,10.62,17.05,15a75,75,0,0,0,11.67,4.83l1.79.53.65-1.74,19.86-52.66,1-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M453.29,114.63s41.66,12.22,31.12,35.65c-13.84,30.78-56.16,33.35-56.16,33.35l25-69m-1.24-2.45-.64,1.77-25,69-1,2.86,3-.18a91.77,91.77,0,0,0,23.46-5.25c16.62-6.06,28.52-16.19,34.41-29.28a18.52,18.52,0,0,0,.16-15.94c-2.88-6.26-9.27-12-19-16.91a86.34,86.34,0,0,0-13.55-5.54l-1.81-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M391.45,114.63s41.65,12.22,31.12,35.65c-13.84,30.78-56.16,33.35-56.16,33.35l25-69m-1.24-2.45-.64,1.77-25,69-1,2.86,3-.18A91.65,91.65,0,0,0,390,180.38c16.63-6.06,28.53-16.19,34.41-29.28a18.52,18.52,0,0,0,.17-15.94c-2.89-6.26-9.27-12-19-16.91A86.34,86.34,0,0,0,392,112.71l-1.81-.53Z"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 162.85,
    cy: 60.14,
    rx: 25.73,
    ry: 3.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 77.93,
    cy: 57.68,
    rx: 25.73,
    ry: 3.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 415.06,
    cy: 34.55,
    rx: 139.36,
    ry: 3.46
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 425.41,
    cy: 34.55,
    rx: 106.7,
    ry: 7.77
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 344.96,
    cy: 60.14,
    rx: 25.73,
    ry: 3.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M676.54,152.38,648,67.23h27.63l18.25,57.68,35.54-57.68h28.76l-54.77,85.15Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M833.87,120.55l22,8.88c-8.4,15.68-26,24.72-47.66,24.72-27.95,0-48.3-17.28-48.3-41.52,0-25.85,21.65-47.17,53.15-47.17,28.6,0,46.69,17.28,46.69,39.9a53.56,53.56,0,0,1-1.13,11.15H784.76C787,127.33,797,133.8,809.31,133.8,820.14,133.8,829.35,129,833.87,120.55ZM786.7,100.68h48c-1-8.08-9.21-15.19-22.94-15.19C800.27,85.49,790.9,91.47,786.7,100.68Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M949.84,92.76a50.12,50.12,0,0,0-10.18-1.13c-18.74,0-31.67,8.08-34.09,26.17l-5,34.58H874.71l12-85.15h25.85l-2.1,14.71c8.4-10.83,19.87-15.19,33.6-15.19a47.26,47.26,0,0,1,9.37,1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M969,120.06c8.24,9.7,22.3,14.87,38.29,14.87,12,0,17.93-3.07,17.93-7.92,0-5.65-10-6-24.88-8.08-16.48-2.26-34.73-6.14-34.73-24.07,0-16.64,15.35-29.4,44.43-29.4,19.87,0,37.16,6.94,45.39,15.83l-14.7,15.19c-7.43-7.27-20-12-33.28-12-11,0-16,2.91-16,7.11,0,4.85,8.72,5.82,21.32,7.43,17.13,2.1,38.62,6.14,38.62,24.56,0,18.58-17.78,30.53-45.89,30.53-21.48,0-40.87-6.94-50.73-17.61Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1142.67,120.55l22,8.88c-8.4,15.68-26,24.72-47.65,24.72-28,0-48.31-17.28-48.31-41.52,0-25.85,21.65-47.17,53.15-47.17,28.6,0,46.69,17.28,46.69,39.9a53.56,53.56,0,0,1-1.13,11.15h-73.83c2.26,10.82,12.28,17.29,24.56,17.29C1128.94,133.8,1138.15,129,1142.67,120.55Zm-47.17-19.87h48c-1-8.08-9.21-15.19-22.94-15.19C1109.07,85.49,1099.7,91.47,1095.5,100.68Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M675.51,150.3l-28.6-85.14h27.63l18.25,57.68,35.55-57.68h28.75L702.33,150.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M757.09,65.16,702.33,150.3H675.51l-28.6-85.14h27.63l18.25,57.68,35.55-57.68h28.75m5.5-3H726.66l-.88,1.43-32.1,52.1L677.4,64.26l-.66-2.1h-34l1.33,4,28.59,85.14.69,2H704l.89-1.37,54.77-85.15,3-4.62Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M832.84,118.47l22,8.89c-8.4,15.67-26,24.72-47.66,24.72-27.95,0-48.31-17.29-48.31-41.52,0-25.85,21.65-47.18,53.15-47.18,28.6,0,46.69,17.29,46.69,39.91a53.62,53.62,0,0,1-1.13,11.15H783.72c2.26,10.82,12.28,17.28,24.56,17.28C819.1,131.72,828.31,126.88,832.84,118.47ZM785.66,98.6h48c-1-8.07-9.21-15.18-22.94-15.18C799.23,83.42,789.86,89.39,785.66,98.6Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M812,63.38c28.6,0,46.69,17.29,46.69,39.91a53.62,53.62,0,0,1-1.13,11.15H783.72c2.26,10.82,12.28,17.28,24.56,17.28,10.82,0,20-4.84,24.56-13.25l22,8.89c-8.4,15.67-26,24.72-47.66,24.72-27.95,0-48.31-17.29-48.31-41.52,0-25.85,21.65-47.18,53.15-47.18M785.66,98.6h48c-1-8.07-9.21-15.18-22.94-15.18-11.47,0-20.84,6-25,15.18M812,60.38c-32,0-56.15,21.57-56.15,50.18,0,25.8,21.58,44.52,51.31,44.52,11.12,0,21.55-2.36,30.17-6.82a47.08,47.08,0,0,0,20.13-19.48l1.58-3-3.1-1.25-17.66-7.14H860l.49-2.4a56.39,56.39,0,0,0,1.19-11.75c0-25.26-20.43-42.91-49.69-42.91Zm-21,35.22c4.43-5.76,11.62-9.18,19.76-9.18,7.64,0,16.13,2.9,19,9.18Zm-3.11,21.84H830c-4,7.07-12.09,11.28-21.7,11.28S791,124.4,787.83,117.44Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M948.8,90.69a50,50,0,0,0-10.18-1.13c-18.74,0-31.66,8.07-34.09,26.17l-5,34.57H873.68l12-85.14h25.85l-2.1,14.7C917.78,69,929.25,64.68,943,64.68a47.26,47.26,0,0,1,9.37,1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M943,64.68a47.26,47.26,0,0,1,9.37,1l-3.55,25a50,50,0,0,0-10.18-1.13c-18.74,0-31.66,8.07-34.09,26.17l-5,34.57H873.68l12-85.14h25.85l-2.1,14.7C917.78,69,929.25,64.68,943,64.68m0-3c-11.94,0-21.61,3.1-29.32,9.45l.79-5.55.49-3.42H883l-.36,2.58-11.95,85.14-.48,3.42h31.89l.37-2.57,5-34.57c2.1-15.67,12.57-23.6,31.12-23.6a46.74,46.74,0,0,1,9.44,1l.2,0,3.07.56.44-3.09,3.56-25,.39-2.81-2.78-.56a50.27,50.27,0,0,0-10-1Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M968,118c8.24,9.69,22.3,14.86,38.29,14.86,12,0,17.94-3.07,17.94-7.91,0-5.66-10-6-24.88-8.08-16.48-2.26-34.74-6.14-34.74-24.07,0-16.64,15.35-29.41,44.43-29.41,19.87,0,37.16,6.95,45.4,15.84l-14.7,15.18c-7.44-7.27-20-12-33.28-12-11,0-16,2.91-16,7.11,0,4.84,8.73,5.81,21.33,7.43,17.12,2.1,38.61,6.14,38.61,24.55,0,18.58-17.77,30.54-45.88,30.54-21.49,0-40.88-7-50.73-17.61Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1009,63.38c19.87,0,37.16,6.95,45.4,15.84l-14.7,15.18c-7.44-7.27-20-12-33.28-12-11,0-16,2.91-16,7.11,0,4.84,8.73,5.81,21.33,7.43,17.12,2.1,38.61,6.14,38.61,24.55,0,18.58-17.77,30.54-45.88,30.54-21.49,0-40.88-7-50.73-17.61L968,118c8.24,9.69,22.3,14.86,38.29,14.86,12,0,17.94-3.07,17.94-7.91,0-5.66-10-6-24.88-8.08-16.48-2.26-34.74-6.14-34.74-24.07,0-16.64,15.35-29.41,44.43-29.41m0-3c-14.44,0-26.49,3.12-34.85,9-8.11,5.73-12.58,14-12.58,23.4,0,21.92,24.28,25.25,37.33,27,2.2.31,4.26.58,6.26.84,7.51,1,16,2.08,16,4.27,0,3-5.86,4.91-14.94,4.91-15.42,0-28.54-5-36-13.8L968,113.38,965.72,116l-14.21,16.48-1.75,2,1.81,2c10.59,11.45,30.88,18.57,52.94,18.57,29.69,0,48.88-13.16,48.88-33.54,0-22.47-27.86-25.89-41.25-27.53l-1.08-.14c-5.81-.74-10.82-1.38-14.15-2.36-2.13-.62-3.46-1.37-3.46-2,0-2,4-4.11,13-4.11,12.23,0,24.18,4.25,31.18,11.1l2.15,2.11,2.1-2.17,14.7-15.19,2-2-1.93-2.08c-9.46-10.21-28.14-16.8-47.6-16.8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1141.64,118.47l22,8.89c-8.4,15.67-26,24.72-47.66,24.72-28,0-48.31-17.29-48.31-41.52,0-25.85,21.65-47.18,53.16-47.18,28.59,0,46.69,17.29,46.69,39.91a53.75,53.75,0,0,1-1.14,11.15h-73.83c2.26,10.82,12.28,17.28,24.56,17.28C1127.9,131.72,1137.11,126.88,1141.64,118.47ZM1094.46,98.6h48c-1-8.07-9.2-15.18-22.94-15.18C1108,83.42,1098.66,89.39,1094.46,98.6Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1120.8,63.38c28.59,0,46.69,17.29,46.69,39.91a53.75,53.75,0,0,1-1.14,11.15h-73.83c2.26,10.82,12.28,17.28,24.56,17.28,10.82,0,20-4.84,24.56-13.25l22,8.89c-8.4,15.67-26,24.72-47.66,24.72-28,0-48.31-17.29-48.31-41.52,0-25.85,21.65-47.18,53.16-47.18M1094.46,98.6h48c-1-8.07-9.2-15.18-22.94-15.18-11.47,0-20.84,6-25,15.18m26.34-38.22c-32,0-56.16,21.57-56.16,50.18,0,25.8,21.58,44.52,51.31,44.52,11.12,0,21.55-2.36,30.17-6.82a47.08,47.08,0,0,0,20.13-19.48l1.58-3-3.1-1.25-17.66-7.14h21.73l.49-2.4a56.56,56.56,0,0,0,1.2-11.75c0-25.26-20.44-42.91-49.69-42.91ZM1099.74,95.6c4.43-5.76,11.62-9.18,19.76-9.18,7.64,0,16.13,2.9,19,9.18Zm-3.11,21.84h42.15c-4,7.07-12.09,11.28-21.7,11.28s-17.29-4.32-20.45-11.28Z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 680.96,
    cy: 127.59,
    rx: 148.58,
    ry: 3.52
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 692,
    cy: 127.59,
    rx: 113.75,
    ry: 7.89
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiitverseLogo);
export default __webpack_public_path__ + "static/media/Swiitverse_logo.4bd7e69435029f7d743e1ee296269f2c.svg";
export { ForwardRef as ReactComponent };